import React from 'react';
import { Zap, Heart, Euro, MapPin } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockData } from '../mock';

const iconMap = {
  Zap,
  Heart,
  Euro,
  MapPin
};

export const AboutSection = () => {
  return (
    <section id="nosotros" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#004534] mb-6">
            Quiénes Somos
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Somos un taller familiar en Torrox, comprometido con agricultores, jardineros y empresas locales. 
            En ERBA trabajamos cada día con eficiencia, confianza y precios justos para mantener tu maquinaria siempre lista.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockData.values.map((value, index) => {
            const IconComponent = iconMap[value.icon];
            return (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-none bg-white">
                <CardContent className="p-8 text-center h-full flex flex-col">
                  <div className="mb-6 flex justify-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#16a34a] to-[#f97316] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-[#004534] mb-4 group-hover:text-[#16a34a] transition-colors">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed flex-grow">
                    {value.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-20 text-center">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl max-w-4xl mx-auto border-l-4 border-[#f97316]">
            <h3 className="text-2xl md:text-3xl font-bold text-[#004534] mb-6">
              Nuestro Compromiso
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              Desde agricultores hasta jardineros y empresas locales: en ERBA mantenemos tus máquinas listas todo el año. 
              Conocemos las necesidades específicas de la Axarquía y trabajamos para que tu negocio nunca se detenga.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};